export default __webpack_public_path__ + "pgnv-assets/46c4b3a96cc14795302cad7319d0ca3d.svg";